<template>
  <div>
    <rest-form-item :label="$t('ChannelConfig_Twilio_Account')" prop="account">
      <el-input
        v-model="model.params.account"
        :placeholder="$t('ChannelConfig_Twilio_Account_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Twilio_Token')" prop="token">
      <el-input
        v-model="model.params.token"
        :placeholder="$t('ChannelConfig_Twilio_Token_Placeholder')"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  components: { RestFormItem },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'twilio')
      this.$set(this.model, 'params', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/Twilio.vue